<template>
  <table class="striped admin-equipment-specifications-table">
    <caption v-html="caption" v-if="caption" />
    <thead>
      <tr>
        <th>Specification</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="specification in paginatedSpecifications"
        :key="specification.id"
        :class="selectedId === specification.id ? 'selected' : 'selectable'"
        @click="handleSelect(specification)"
      >
        <td>{{ specification.name }}</td>
      </tr>
      <tr v-if="specifications.length === 0">
        <td class="no-records">
          There are currently no equipment specifications in the system.
        </td>
      </tr>
    </tbody>
    <tfoot v-if="hasPages">
      <tr>
        <td class="page-controls">
          <icon-button
            :disabled="!hasPrevPage"
            name="prev"
            @click="goToPrevPage"
          />

          <icon-button
            :disabled="!hasNextPage"
            name="next"
            @click="goToNextPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { pagination } from "../../mixins/pagination";

export default {
  mixins: [pagination("specifications")],

  props: {
    caption: {
      type: String,
      default: undefined,
    },
    selectedId: {
      type: Number,
      default: -1,
    },
    specifications: {
      type: Array,
    },
  },

  methods: {
    handleSelect(specification) {
      this.$emit("select", specification);
    },
  },
};
</script>